var _path, _path2, _path3, _path4, _path5, _g, _circle, _circle2, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6216 34.7087C37.6216 34.7087 38.3497 35.7621 40.6689 37.2403C40.8425 37.3495 41.0245 37.4624 41.2162 37.5765C41.9444 38.0121 42.8 38.4757 43.8109 38.9563L44.0536 32.767C44.0536 32.767 47.209 33.0097 50.0002 31.7961C49.6786 31.6359 48.2927 30.8896 46.3 29.3447C46.1216 29.2075 45.9359 29.0619 45.749 28.9102C44.8679 28.2015 43.8861 27.3483 42.8364 26.335C41.2624 29.0049 37.6216 34.7087 37.6216 34.7087Z",
    fill: "url(#paint0_linear_27_785)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3786 34.3447C12.3786 34.3447 11.6505 35.3981 9.33131 36.8762C9.15777 36.9854 8.97573 37.0983 8.78398 37.2124C8.05583 37.6481 7.20631 38.1117 6.18932 38.5922L5.9466 32.4029C5.9466 32.4029 2.79126 32.6456 0 31.4321C0.321602 31.2719 1.70752 30.5255 3.70024 28.9806C3.87864 28.8435 4.06432 28.6978 4.25121 28.5461C5.13228 27.8374 6.11408 26.9842 7.16384 25.9709C8.73786 28.6408 12.3786 34.3447 12.3786 34.3447Z",
    fill: "url(#paint1_linear_27_785)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33126 36.8762C9.15772 36.9855 8.97568 37.0983 8.78393 37.2124C8.35068 35.8059 6.62374 32.6991 5.94655 31.7961C5.46999 31.1483 4.94242 30.5396 4.36888 29.9758C4.14437 29.7512 3.87374 29.2961 3.7002 28.9806C3.87859 28.8435 4.06427 28.6978 4.25117 28.5461C4.47204 28.8957 4.80699 29.4187 5.10068 29.8544C5.58612 30.5826 8.6201 34.466 8.98418 35.1942C9.22325 35.6772 9.30335 36.426 9.33126 36.8762Z",
    fill: "#9925E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 3.05176e-05C35.858 3.05176e-05 44.6601 8.80218 44.6602 19.6602C44.6602 30.5182 35.858 39.3203 25 39.3203C14.142 39.3203 5.33984 30.5182 5.33984 19.6602C5.33986 8.80219 14.142 5.11351e-05 25 3.05176e-05ZM25 4.73343C16.756 4.73343 10.0733 11.4162 10.0732 19.6602C10.0732 27.9042 16.7559 34.5869 25 34.5869C33.2441 34.5869 39.9268 27.9042 39.9268 19.6602C39.9267 11.4162 33.244 4.73343 25 4.73343Z",
    fill: "#6C7E92"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_785",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 0,
    width: 40,
    height: 40
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 3.05176e-05C35.858 3.05176e-05 44.6601 8.80218 44.6602 19.6602C44.6602 30.5182 35.858 39.3203 25 39.3203C14.142 39.3203 5.33984 30.5182 5.33984 19.6602C5.33986 8.80219 14.142 5.11351e-05 25 3.05176e-05ZM25 4.73343C16.756 4.73343 10.0733 11.4162 10.0732 19.6602C10.0732 27.9042 16.7559 34.5869 25 34.5869C33.2441 34.5869 39.9268 27.9042 39.9268 19.6602C39.9267 11.4162 33.244 4.73343 25 4.73343Z",
    fill: "#6C7E92"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_785)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_27_785)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.9826,
    cy: 6.70771,
    rx: 4.49029,
    ry: 9.10194,
    transform: "rotate(42.5525 12.9826 6.70771)",
    fill: "#F0F2F7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_27_785)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.6873,
    cy: 6.70773,
    rx: 4.49029,
    ry: 9.10194,
    transform: "rotate(150 37.6873 6.70773)",
    fill: "#F0F2F7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_27_785)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.946,
    cy: 33.0336,
    rx: 4.49029,
    ry: 9.10194,
    transform: "rotate(-135 35.946 33.0336)",
    fill: "#F0F2F7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_27_785)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.1307,
    cy: 31.3345,
    rx: 4.49029,
    ry: 9.10194,
    transform: "rotate(-45 13.1307 31.3345)",
    fill: "#889BAF"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.9999,
    cy: 19.6602,
    r: 14.9272,
    fill: "url(#paint2_linear_27_785)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.9999,
    cy: 19.6602,
    r: 14.6238,
    stroke: "url(#paint3_linear_27_785)",
    strokeWidth: 0.606796
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25 3.64081C33.8472 3.64087 41.0195 10.8131 41.0195 19.6603C41.0195 28.5075 33.8472 35.6798 25 35.6799C16.1528 35.6799 8.98053 28.5076 8.98047 19.6603C8.98047 10.8131 16.1527 3.64081 25 3.64081ZM25 4.7326C16.7559 4.7326 10.0732 11.4163 10.0732 19.6603C10.0733 27.9043 16.756 34.5871 25 34.5871C33.244 34.5871 39.9267 27.9043 39.9268 19.6603C39.9268 11.4163 33.2441 4.73261 25 4.7326Z",
    fill: "url(#paint4_linear_27_785)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.761 26.7836C28.557 26.7834 28.3561 26.733 28.1761 26.6368L25.1081 25.0251C25.0673 25.0037 25.0219 24.9924 24.9758 24.9924C24.9298 24.9924 24.8844 25.0037 24.8436 25.0251L21.7756 26.6368C21.5956 26.733 21.3947 26.7834 21.1907 26.7836C21.0077 26.783 20.8271 26.7426 20.6613 26.6651C20.4956 26.5877 20.3487 26.475 20.2309 26.3351C20.1131 26.1951 20.0272 26.0311 19.9791 25.8546C19.9311 25.678 19.9221 25.4931 19.9528 25.3127L20.539 21.8977C20.5468 21.8521 20.5434 21.8052 20.529 21.7612C20.5146 21.7172 20.4897 21.6774 20.4564 21.6453L17.9759 19.2266C17.8083 19.0629 17.6898 18.8556 17.6337 18.6281C17.5776 18.4007 17.5862 18.1621 17.6585 17.9392C17.7308 17.7164 17.864 17.5182 18.0429 17.367C18.2218 17.2157 18.4395 17.1175 18.6712 17.0834L22.1008 16.5858C22.1466 16.5789 22.19 16.5611 22.2274 16.5338C22.2648 16.5066 22.2951 16.4707 22.3157 16.4293L23.8496 13.3212C23.9534 13.1112 24.1138 12.9343 24.3129 12.8106C24.5119 12.6869 24.7415 12.6214 24.9758 12.6214C25.2102 12.6214 25.4398 12.6869 25.6388 12.8106C25.8379 12.9343 25.9983 13.1112 26.1021 13.3212L27.636 16.4293C27.6566 16.4707 27.6869 16.5066 27.7243 16.5338C27.7617 16.5611 27.8051 16.5789 27.8509 16.5858L31.2805 17.0834C31.5122 17.1175 31.7299 17.2157 31.9088 17.367C32.0877 17.5182 32.2209 17.7164 32.2932 17.9392C32.3655 18.1621 32.3741 18.4007 32.318 18.6281C32.2619 18.8556 32.1434 19.0629 31.9759 19.2266L29.4953 21.6453C29.462 21.6774 29.4371 21.7172 29.4227 21.7612C29.4083 21.8052 29.4049 21.8521 29.4127 21.8977L29.9989 25.3127C30.0296 25.4931 30.0206 25.678 29.9726 25.8546C29.9245 26.0311 29.8386 26.1951 29.7208 26.3351C29.603 26.475 29.4561 26.5877 29.2904 26.6651C29.1246 26.7426 28.944 26.783 28.761 26.7836Z",
    fill: "#053A4C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.667 13.5369L27.201 16.6449C27.2565 16.7567 27.3383 16.8534 27.4393 16.9267C27.5403 17.0001 27.6576 17.0479 27.7811 17.066L31.2107 17.5648C31.353 17.5855 31.4867 17.6455 31.5966 17.7382C31.7065 17.8309 31.7883 17.9525 31.8328 18.0892C31.8772 18.2259 31.8825 18.3724 31.8481 18.512C31.8136 18.6515 31.7409 18.7787 31.6379 18.8791L29.1561 21.2978C29.0668 21.3851 29 21.4928 28.9615 21.6116C28.9231 21.7304 28.914 21.8568 28.9352 21.9798L29.5202 25.3961C29.5448 25.5378 29.5292 25.6836 29.4752 25.817C29.4211 25.9503 29.3307 26.0658 29.2143 26.1503C29.0979 26.2349 28.9602 26.2851 28.8167 26.2953C28.6732 26.3055 28.5297 26.2752 28.4025 26.208L25.3406 24.5963C25.2299 24.5378 25.1066 24.5072 24.9814 24.5072C24.8561 24.5072 24.7328 24.5378 24.6221 24.5963L21.5505 26.208C21.4234 26.2752 21.2799 26.3055 21.1364 26.2953C20.9929 26.2851 20.8551 26.2349 20.7387 26.1503C20.6223 26.0658 20.5319 25.9503 20.4779 25.817C20.4238 25.6836 20.4082 25.5378 20.4328 25.3961L21.0178 21.9798C21.039 21.8568 21.03 21.7304 20.9915 21.6116C20.953 21.4928 20.8862 21.3851 20.7969 21.2978L18.3151 18.8791C18.2122 18.7787 18.1394 18.6515 18.1049 18.512C18.0705 18.3724 18.0758 18.2259 18.1203 18.0892C18.1647 17.9525 18.2465 17.8309 18.3564 17.7382C18.4664 17.6455 18.6 17.5855 18.7423 17.5648L22.1719 17.066C22.2954 17.0479 22.4127 17.0001 22.5137 16.9267C22.6147 16.8534 22.6965 16.7567 22.752 16.6449L24.286 13.5369C24.3494 13.4078 24.4477 13.2991 24.5698 13.2231C24.6918 13.1471 24.8327 13.1068 24.9765 13.1068C25.1203 13.1068 25.2612 13.1471 25.3833 13.2231C25.5053 13.2991 25.6036 13.4078 25.667 13.5369Z",
    fill: "url(#paint5_linear_27_785)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M40.4127 7.46362C39.4888 8.56925 38.6484 9.42297 37.6233 10.4155C37.5474 10.4909 37.4715 10.5663 37.3955 10.6417C37.3449 10.6919 37.3069 10.7296 37.2563 10.7799C37.0665 10.9558 36.8767 11.1442 36.6742 11.3201C36.5982 11.3829 36.535 11.4458 36.459 11.5211C36.4084 11.5588 36.3578 11.6091 36.3198 11.6468C36.2566 11.7096 36.1933 11.7599 36.13 11.8101C29.3974 17.7277 20.8425 21.3336 11.8067 21.9869C11.7181 21.9869 11.6421 21.9995 11.5536 21.9995C11.4903 21.9995 11.427 22.012 11.3637 22.012C11.2625 22.012 11.1739 22.0246 11.0727 22.0246C10.7436 22.0372 10.4146 22.0623 10.0856 22.0623C9.98431 22.0623 9.87041 22.0748 9.76917 22.0748C9.51607 22.0874 9.26296 22.0874 9.02251 22.0874C7.84558 22.0874 6.66864 22.0497 5.47905 21.9492C5.39046 21.2079 5.33984 20.4415 5.33984 19.6751C5.33984 8.80734 14.2112 3.05176e-05 25.1453 3.05176e-05C30.0681 3.05176e-05 34.4573 1.88931 37.9248 4.8544C38.8233 5.6208 39.6533 6.54646 40.4127 7.46362Z",
    fill: "url(#paint6_linear_27_785)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_27_785",
    x: -1.16703,
    y: -7.81489,
    width: 28.2989,
    height: 29.0452,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5801,
    result: "effect1_foregroundBlur_27_785"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_27_785",
    x: 24.541,
    y: -8.65058,
    width: 26.2926,
    height: 30.7166,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5801,
    result: "effect1_foregroundBlur_27_785"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_27_785",
    x: 21.6074,
    y: 18.6951,
    width: 28.6768,
    height: 28.6769,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5801,
    result: "effect1_foregroundBlur_27_785"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_27_785",
    x: -1.20756,
    y: 16.9961,
    width: 28.6768,
    height: 28.6768,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5801,
    result: "effect1_foregroundBlur_27_785"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_785",
    x1: 46.4201,
    y1: 35.3155,
    x2: 40.1094,
    y2: 31.3714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9D00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#7B00DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#9825E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#6800B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#400071"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_27_785",
    x1: 2.71481,
    y1: 35.3095,
    x2: 10.085,
    y2: 30.1481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9D00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#7B00DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#9825E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#6800B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#400071"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_27_785",
    x1: 24.9999,
    y1: 4.73303,
    x2: 24.9999,
    y2: 34.5874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A99A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#10667B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#184A61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_27_785",
    x1: 24.9999,
    y1: 4.73303,
    x2: 24.9999,
    y2: 34.5874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F879B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#062C3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_27_785",
    x1: 24.9999,
    y1: 3.64081,
    x2: 24.9999,
    y2: 35.6796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C4E56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADBED2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_27_785",
    x1: 24.9765,
    y1: 13.2347,
    x2: 24.9765,
    y2: 24.7153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#C8D0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#C8D1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#566B7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9B8CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_27_785",
    x1: 14.6072,
    y1: 3.03086,
    x2: 25.7134,
    y2: 18.5763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5084,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecond);
export default __webpack_public_path__ + "static/media/second.7cc0b2ff30ea607b9b49b0529fc6b5ad.svg";
export { ForwardRef as ReactComponent };